import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export function usePlanSubscribe() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  interface SubscribeData {
    subscription: string;
  }

  interface PlanData {
    priceId: string;
    paymentMethodId: string;
  }

  return useMutation({
    mutationFn: async (planData: PlanData): Promise<SubscribeData> => {

      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/subscribe_to_plan`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: JSON.stringify(planData)
        }
      );
      const data = await response.json();

      const { subscription } = data?.data;

      return {
        subscription: subscription
      };
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['userConfig']);
    },
  });
}